import AppService from 'App/legacy/AppService';
const getAccount = appointment => {
	return new Promise(resolve => {
		Tools.Account.customer(AppService.getCustomerId())
			.get(appointment.client.id)
			.then(response => {
				return resolve(response.data);
			});
	});
};

export default getAccount;
